<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" (click)="windowClick()">
  <dialog-header [label]="'ACTIONS.JUMP_TO' | translate" [dialogRef]='dialogRef' (mousedown)="windowClick()" [object]='this'>
  </dialog-header>
  <mat-dialog-content>
    <crdt #crdt (submit)="onSubmit()"></crdt>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-stroked-button (click)="onView()" [disabled]="!crdt.valid">{{tempMarker ? ('ACTIONS.HIDE' | translate) :
      ('ACTIONS.VIEW' | translate)}}</button>
    <button mat-stroked-button (click)="onCenter()" [disabled]="!crdt.valid">{{'ACTIONS.CENTER' | translate}}</button>
    <button mat-stroked-button (click)="dialogRef.close()">{{'ACTIONS.CLOSE' | translate}}</button>
  </mat-dialog-actions>
</div>